import { render, staticRenderFns } from "./brochure.vue?vue&type=template&id=9f3d7c6a&scoped=true"
import script from "./brochure.vue?vue&type=script&lang=js"
export * from "./brochure.vue?vue&type=script&lang=js"
import style0 from "./brochure.vue?vue&type=style&index=0&id=9f3d7c6a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3d7c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f3d7c6a')) {
      api.createRecord('9f3d7c6a', component.options)
    } else {
      api.reload('9f3d7c6a', component.options)
    }
    module.hot.accept("./brochure.vue?vue&type=template&id=9f3d7c6a&scoped=true", function () {
      api.rerender('9f3d7c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/neewerdownload/brochure.vue"
export default component.exports